import { Navigate } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import CasualDetails from "../pages/play/CasualDetails";
import CasualPlay from "../pages/play/CasualPlay";
import Events from "../pages/events/Events";
import EventsPlay from "../pages/events/EventsPlay";
import ArmyListSearchOld from "../pages/lists/ArmyListSearchOld";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import ArmyListSearch from "../pages/lists/ArmyListSearch";
import { getEnvironmentVariable } from "../global/environmentVariables";
import { isAppMode } from "../global/AppOverlay";
import SubscriptionNotice from "../pages/subscription/SubscriptionNotice";
import PlayDashboard from "../pages/play/PlayDashboard";
import OrganizationSearch from "../pages/organizations/OrganizationSearch";
import PlayCircuits from "../pages/play/PlayCircuits";
const NO_SUBSCRIPTIONS = getEnvironmentVariable("NO_SUBSCRIPTIONS") === "true";

export const playRoutes = (authContext, itemsMiddle, setItemsMiddle) => {
  const forceLoginParam = findGetParameter("forceLogin");
  const appMode = isAppMode();

  return [
    {
      path: "play",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            play
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "/play/",
          element: authContext?.authState?.isAuthenticated ? (
            <PlayDashboard />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "dashboard",
          element: authContext?.authState?.isAuthenticated ? (
            <PlayDashboard />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "organizations",
          element: <OrganizationSearch />
        },
        {
          path: "circuits",
          element: authContext?.authState?.isAuthenticated ? (
            <PlayCircuits />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "my-events",
          element: authContext?.authState?.isAuthenticated ? (
            <EventsPlay />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "my-games",
          element: authContext?.authState?.isAuthenticated ? (
            <CasualPlay />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "new-game",
          element: authContext?.authState?.isAuthenticated ? (
            <CasualDetails />
          ) : (
            <LoginRedirect />
          )
        },
        {
          path: "events",
          element: <Events />
        },
        {
          path: "list-search-old",
          element:
            NO_SUBSCRIPTIONS ||
            authContext?.authState?.identity?.subscriber ||
            authContext?.authState?.identity?.isAdmin === true ? (
              <ArmyListSearchOld />
            ) : !authContext?.authState?.isAuthenticated ? (
              <LoginRedirect />
            ) : appMode ? (
              <SubscriptionNotice />
            ) : (
              <Navigate to="/subscription?subFeature=true" />
            )
        },
        {
          path: "list-search",
          element:
            NO_SUBSCRIPTIONS ||
            authContext?.authState?.identity?.subscriber ||
            authContext?.authState?.identity?.isAdmin === true ? (
              <ArmyListSearch />
            ) : !authContext?.authState?.isAuthenticated ? (
              <LoginRedirect />
            ) : appMode ? (
              <SubscriptionNotice />
            ) : (
              <Navigate to="/subscription?subFeature=true" />
            )
        },
        {
          path: "spell-book-search",
          element:
            NO_SUBSCRIPTIONS ||
            authContext?.authState?.identity?.subscriber ||
            authContext?.authState?.identity?.isAdmin === true ? (
              <ArmyListSearch />
            ) : !authContext?.authState?.isAuthenticated ? (
              <LoginRedirect />
            ) : appMode ? (
              <SubscriptionNotice />
            ) : (
              <Navigate to="/subscription?subFeature=true" />
            )
        }
      ]
    }
  ];
};
